import axios from 'axios'

const URL_PATH = 'api/revisoes'

class ModeloDocumentoRevisaoApiClient {
	async salvarModeloDocumentoRevisao(idRevisao, body) {
		return await axios.post(`${URL_PATH}/${idRevisao}/modelo-documento`, body)
	}

	async removerModeloDocumentoRevisao(idRevisao) {
		return await axios.delete(`${URL_PATH}/${idRevisao}/modelo-documento`)
	}

	async redigirModeloDocumentoRevisao(idRevisao) {
		return await axios.put(`${URL_PATH}/${idRevisao}/modelo-documento/redigir`)
	}

	async visualizarModeloDocumentoRevisao(idRevisao) {
		return await axios.get(`${URL_PATH}/${idRevisao}/documentos-editor`)
	}
}

export default new ModeloDocumentoRevisaoApiClient()
